/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TicketPromoCodeDetail } from './TicketPromoCodeDetail';
import {
    TicketPromoCodeDetailFromJSON,
    TicketPromoCodeDetailFromJSONTyped,
    TicketPromoCodeDetailToJSON,
    TicketPromoCodeDetailToJSONTyped,
} from './TicketPromoCodeDetail';

/**
 * 
 * @export
 * @interface ResultOfIReadOnlyListOfTicketPromoCodeDetail
 */
export interface ResultOfIReadOnlyListOfTicketPromoCodeDetail {
    /**
     * 
     * @type {Array<TicketPromoCodeDetail>}
     * @memberof ResultOfIReadOnlyListOfTicketPromoCodeDetail
     */
    data: Array<TicketPromoCodeDetail> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfIReadOnlyListOfTicketPromoCodeDetail
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfIReadOnlyListOfTicketPromoCodeDetail
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfIReadOnlyListOfTicketPromoCodeDetail interface.
 */
export function instanceOfResultOfIReadOnlyListOfTicketPromoCodeDetail(value: object): value is ResultOfIReadOnlyListOfTicketPromoCodeDetail {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfIReadOnlyListOfTicketPromoCodeDetailFromJSON(json: any): ResultOfIReadOnlyListOfTicketPromoCodeDetail {
    return ResultOfIReadOnlyListOfTicketPromoCodeDetailFromJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfTicketPromoCodeDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfIReadOnlyListOfTicketPromoCodeDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(TicketPromoCodeDetailFromJSON)),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfIReadOnlyListOfTicketPromoCodeDetailToJSON(json: any): ResultOfIReadOnlyListOfTicketPromoCodeDetail {
    return ResultOfIReadOnlyListOfTicketPromoCodeDetailToJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfTicketPromoCodeDetailToJSONTyped(value?: ResultOfIReadOnlyListOfTicketPromoCodeDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(TicketPromoCodeDetailToJSON)),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

